import axios from "axios";

/**
 * For S3 presigned URLs ONLY. A presigned PUT/GET is authorized by its
 * query-string signature; adding an Authorization header breaks the
 * signature (403 SignatureDoesNotMatch). No interceptors, by construction —
 * never attach the auth interceptor to this instance.
 */
const presignedClient = axios.create();

export default presignedClient;
